module.exports = __webpack_public_path__ + "static/media/coffee-small.142c1a35.mp4";